import { AlertTriangle } from 'lucide-react';
import EmptyState from '../../components/EmptyState';
import Button from '../../components/Button';
import { formatCurrency } from '../../data/mockData';
import { formatPrice, formatStock, isSoldByWeight } from '../../utils/soldBy';
import styles from './Inventory.module.css';

export default function LowStockPanel({ products, onStockIn }) {
  const low = products.filter((p) => p.stock <= p.lowStockThreshold);

  if (low.length === 0) {
    return <EmptyState icon={AlertTriangle} title="Nothing running low" description="All products are above their alert threshold." />;
  }

  return (
    <div className={styles.lowGrid}>
      {low.map((p) => (
        <div key={p.id} className={styles.lowCard}>
          <span className={styles.lowSwatch} style={{ background: `${p.swatch}22`, color: p.swatch }}>{p.emoji}</span>
          <div className={styles.lowInfo}>
            <p className={styles.lowName}>{p.name}</p>
            <p className={styles.lowMeta}>
              {p.stock === 0
                ? 'Out of stock'
                : `${isSoldByWeight(p) ? formatStock(p.stock, p) : `${p.stock} ${p.unit}`} left`}
              {' · '}
              alert at {isSoldByWeight(p) ? formatStock(p.lowStockThreshold, p) : p.lowStockThreshold}
            </p>
            <p className={styles.lowPrice}>{formatPrice(p, formatCurrency)}</p>
          </div>
          <Button size="sm" variant="outline" onClick={() => onStockIn(p.id)}>Stock in</Button>
        </div>
      ))}
    </div>
  );
}
